"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _engineHelper = _interopRequireDefault(require("./engineHelper"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class SearchButton extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonText: props.searchText
    };
    this.onClick = this.onClick.bind(this);
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (_engineHelper.default.checkUpdated(nextState.buttonText, this.state.buttonText)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.searchText, this.props.searchText)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.location, this.props.location)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.productType, this.props.productType)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.reset, this.props.reset)) return true;
    return false;
  }
  componentDidUpdate(prevProps) {
    if (!prevProps.reset && this.props.reset) this.resetButtonText();
  }
  componentDidMount() {
    window.onpageshow = e => {
      if (e.persisted) window.location.reload();
    };
  }
  resetButtonText() {
    this.setState({
      buttonText: this.props.searchText
    });
  }
  isFormInvalid(form) {
    return !form || !!form.querySelector('.has-error');
  }
  onClick(e) {
    const self = this;
    const thisTarget = e.currentTarget;
    if (this.props.showPleaseWaitText) {
      setTimeout(() => {
        if (!self.isFormInvalid(thisTarget.form)) {
          self.setState({
            buttonText: self.props.pleaseWaitText
          });
        }
      }, 50);
    }
    if (this.props.onClick) this.props.onClick(e);
  }
  render() {
    const {
      buttonText
    } = this.state;
    const {
      containerClasses,
      hideArrow
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: containerClasses
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "btn hx-btn-ultimate btn-lg btn-block submit hxtrack",
      "data-hxtrack-name": "engine-search-button",
      "data-track-name": "search-button",
      type: "submit",
      onClick: this.onClick
    }, /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: buttonText
      }
    }), !hideArrow && /*#__PURE__*/_react.default.createElement("i", {
      className: "fa fa-arrow-right"
    })));
  }
}
SearchButton.propTypes = {
  searchText: _propTypes.string,
  pleaseWaitText: _propTypes.string,
  onClick: _propTypes.func,
  location: _propTypes.string,
  productType: _propTypes.string,
  reset: _propTypes.bool,
  showPleaseWaitText: _propTypes.bool,
  containerClasses: _propTypes.string,
  hideArrow: _propTypes.bool
};
SearchButton.defaultProps = {
  searchText: 'Find parking',
  pleaseWaitText: 'Please wait ...',
  showPleaseWaitText: true,
  containerClasses: '',
  hideArrow: true
};
var _default = exports.default = SearchButton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-booking-forms-aps/lib/components/searchButton.js
// module id = 401
// module chunks = 119